import React, {Component} from 'react';
import ReactModal from "react-modal"
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import styled from 'styled-components';
import Levels from '../../src/data';
import { setGameOptions } from '../actions'
import CurrentLevel from './currentlevel';
import ProgressBar from './progressbar';
import WordGrid from './wordgrid';
import { connect } from "react-redux"
import { CONSTANTS } from '../static/constants';

const ErrorMessage = styled.div`
	border-radius: 5px;
    background-color: ${CONSTANTS.red};
    color: white;
    width: 300px;
    margin-left: -150px;
    left: 50%;
    padding: 15px;
    position: absolute;
	opacity: 0;
	bottom: 0;
	transition: all .2s ease-out;
	&.show {
		bottom: 20px;
		opacity: 1;
	}
`;

class GameMode extends Component{
	constructor(props) {
    super(props);
		// changes lives based on review mode
		const reviewMode = this.props.match.params.review === 'review';
		this.props.setGameOptions({ lives: reviewMode ? 5 : 3 });
		this.state = {
			showModal: false,
			hearts: reviewMode ? [true, true, true, true, true] : [true, true, true]
		};
	}
	componentWillMount() {
		const reviewMode = this.props.match.params.review === 'review';
		const currentLevel = parseInt(this.props.match.params.level, 10);
		this.props.setGameOptions({ words: reviewMode 
			?
			// grab all words from last 4 levels
			[].concat(...new Array(4).fill(undefined).map((val,key) => (
				Levels[currentLevel - (key + 1)].words.map((val) => ({ 
						...val,
						keySyllable: Levels[currentLevel - (key + 1)].korean,
						altChar: Levels[currentLevel - (key + 1)].altchar
					}))
			)))
      :
			[...Levels[currentLevel].words.map((val) => ({ 
					...val,
					keySyllable: Levels[currentLevel].korean,
					altChar: Levels[currentLevel].altchar
			}))]
		});
	}
	checkWordComplete = (char, isKeySyllable) => {
		const {currentWord, match, words, syllablesComplete, unlockedLevel, needsReview, setGameOptions, history} = this.props
		//check if need to show user if new hanja is unlocked
		console.log(isKeySyllable, 'ddqeqwe');
		const reviewMode = match.params.review === 'review';
		const currentLevel = parseInt(match.params.level, 10);
		const isReviewLevel = needsReview && currentLevel === unlockedLevel
		const isKeySyllable2 = Levels[currentLevel + 1].korean === char;
		if(!reviewMode) {
			const isUnlockWord = words[currentWord].unlock !== undefined;
			if(isUnlockWord && isKeySyllable2){
				this.handleOpenModal();
			}
		}
		const completePlus = syllablesComplete + 1;
		this.props.setGameOptions({syllables_complete: completePlus});
			//this.props.setWord(this.props.currentWord + 1);
		//check word completed or level completed
		let wordComplete = words[currentWord].korword.split("").length === completePlus;
		let levelComplete = currentWord === words.length -1;
		if(wordComplete){
			if(!levelComplete){
				this.props.setGameOptions({ current_word: currentWord + 1, syllables_complete: 1 });
			}else{
				//level complete
				const that = this;
				// set state progress bar fills up fully
				this.setState({levelComplete: true})
				setTimeout(function(){
					history.push('/levelComplete/' + currentLevel)
					setGameOptions({ 
						current_word: 0,
						syllables_complete: 1,
						unlocked_level: reviewMode || (currentLevel !== unlockedLevel) ? unlockedLevel : currentLevel + 1
					});

				}, 800);
			}
		}
  }
 	handleOpenModal = () => {
    this.setState({ showModal: true });
	}
	handleCloseModal = () => {
    this.setState({ showModal: false });
	}
	showMistake = (hanja, englishMeaning) => {
		this.setState({showMistake: true, wrongHanja: hanja, englishMeaning: englishMeaning});
		setTimeout(() => {
			this.setState({
				showMistake: false
			})
		}, 2000);
	}
	render(){
		const { currentWord } = this.props
		const currentLevel = parseInt(this.props.match.params.level, 10);
		const progress = this.state.levelComplete ? 100 : (currentWord / this.props.words.length) * 100
		const levelComplete = currentWord === this.props.words.length;
		const style = {width: `${progress}%`};
		const nextLevel = Levels[currentLevel + 1];
		// if it's review, use words from last two levels, otherwise current
		const reviewMode = this.props.match.params.review === 'review';;
		const wordGrids = this.props.words.map((val, key)=>{
      return <WordGrid
        currentWord={this.props.currentWord}
				word={val}
				keySyllable={this.keySyllable}
				altChar={this.altChar}
        history={this.props.history}
        currentLevel={currentLevel}
        showMistake={this.showMistake}
        key={key}
        id={key}
				checkWordComplete={this.checkWordComplete}
        showUnlockModal={this.handleOpenModal} />
		});
		const livesArray = this.state.hearts.map((val, key) => {
			if (key < this.props.lives) {
				return true;
			} else {
				return false;
			}
		});
		return(
			<div>
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel="Hanja Unlocked"
          className="Modal"
          shouldCloseOnOverlayClick={false}
          onRequestClose={this.handleCloseModal}
          overlayClassName="Overlay"
          >
          <span className="unlocked-title">You Unlocked a New Hanja!</span>
          <div className="unlocked-card">
            <div className="unlocked-header"><div className="display-korean"><span>{nextLevel.korean}</span></div></div>
            <ul className="word-list">
              <li>
                <span>English meaning</span>
                <span>{nextLevel.english}</span>

              </li>
              <li>
                <span>Chinese hanja</span>
                <span>{nextLevel.hanja}</span>

              </li>
            </ul>
          </div>
          <button onClick={this.handleCloseModal}>CONTINUE</button>
        </ReactModal>
				<div className="game-header">
					<div className="game-indicator-wrap">
						<CurrentLevel levelName={reviewMode 
							?
							[
								Levels[currentLevel - 1].korean,
								Levels[currentLevel - 2].korean,
								Levels[currentLevel - 3].korean,
								Levels[currentLevel - 4].korean,
							]
							:
							[Levels[currentLevel].korean, Levels[currentLevel].english]
							}
						/>
						<div className="lives">
							{ livesArray.map((val, key) => <img key={key} src={require('../assets/heart.svg')} className={'life ' +  (val ? '' : 'lost-life') } alt='heart' /> ) }
						</div>
					</div>
					<div className="clear" />
					<ProgressBar progressStyle={style} />
				</div>
				<div className="game-body">
					{this.props.lives > 0 ? (
						<div>
							<span className="level-instruction">Choose the Korean for </span>
							<span className="level-title">{ this.props.words.length ? this.props.words[currentWord].engword : ''}</span>
						</div>
					) : (<span className="level-title gameover">You ran out of lives</span>)}
					<ReactCSSTransitionReplace
						key="rcsstrc"
						transitionName={this.props.lives === 0 ? null : 'fade'}
						transitionEnterTimeout={2000}
						transitionLeaveTimeout={2000}
						transitionAppear={true}
						transitionAppearTimeout={500}
						overflowHidden={false}>
						<div key={currentWord}>
							{this.props.lives > 0 ? wordGrids[currentWord] : (
								<div>
									<button onClick={() => this.props.setGameOptions({ lives: reviewMode ? 5 : 3, current_word: 0 })}>Try Again</button>
								</div>
							)}
						</div>
					</ReactCSSTransitionReplace>
					<div className="game-body-bg">{ Levels[currentLevel].hanja }</div>
					<ErrorMessage className={this.state.showMistake ? 'show' : ''}>
						{this.state.wrongHanja} means { this.state.englishMeaning}
					</ErrorMessage>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ({ GameOptions }) => {
  return {
    currentWord: GameOptions.current_word,
		needsReview: GameOptions.needs_review,
		syllablesComplete: GameOptions.syllables_complete,
		words: GameOptions.words,
		lives: GameOptions.lives,
		unlockedLevel: GameOptions.unlocked_level
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setGameOptions: GameOptions => {
      dispatch(setGameOptions(GameOptions));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(GameMode);



// WEBPACK FOOTER //
// ./src/components/gamemode.js